 <div class="row entry-row">
    <div class="col-12 col-sm-auto">
        <h1 class="content-header-title" *ngIf="task">
            {{ task.name }}
        </h1>
    </div>

    <div class="col-lg-auto pl-lg-0">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a routerLink="/"><i class="fa fa-home"></i> </a>
            </li>
            <li class="breadcrumb-item">
                <a routerLink="/tasks">{{ '::Menu:Tasks' | abpLocalization }}</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
                {{ "::ViewTask"  | abpLocalization }}
            </li>
        </ol>
    </div>
</div> 

<div class="row" *ngIf="!isLoading">
    <div class="col-lg-9 col-sm-12">
        <div class="card d-flex">
            <div class="card-body">
                <ul class="nav nav-tabs mb-3" id="myTab0" role="tablist">
                    <li class="nav-item" role="presentation">
                        <span
                            class="nav-link active"
                        >
                            {{ '::MainInformation' | abpLocalization }}
                        </span>
                    </li>
                </ul>
                <div class="tab-content">
                    <form [formGroup]="form" class="col-md-8">
                        <div class="form-group mb-3">
                            <label class="form-label" for="name">{{ '::Name' | abpLocalization }}</label>
                            <input type="text" id="name" class="form-control" formControlName="name" [readOnly]="true" [abpDisabled]="true"/>
                        </div>
                        
                        <div class="form-group mb-3">
                            <label class="form-label" for="description">
                                {{ '::Description' | abpLocalization }}
                            </label>
                            <textarea
                                id="description"
                                class="form-control"
                                cols="30"
                                rows="10"
                                formControlName="description"
                                [readOnly]="true" 
                                [abpDisabled]="true"
                            ></textarea>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-sm-12" *ngIf="isAbleToCompleteTask()">
        <div class="card overflow-auto">
            <div class="card-title">
                <h3 class="card-title m-2 mx-3">
                    {{ '::Task' | abpLocalization }}
                </h3>
            </div>
            <ul class="list-group">
                <li 
                    class="list-group-item list-group-item-action"
                >
                    <div class="d-flex">
                        <div class="me-auto">{{ task.name }}</div>
                        <button 
                            class="btn btn-primary btn-sm"
                            (click)="updateTaskStatus(task.id)"
                        >
                            {{ '::Done' | abpLocalization }}
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
<div>
    
